module.exports = __webpack_public_path__ + "static/img/deploy1.75fd811.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/deploy1.png
// module id = 03Sx
// module chunks = 1